module.exports = __webpack_public_path__ + "img/فانتزی.ec1d809b.png";